import { render, staticRenderFns } from "./triple_arrows.vue?vue&type=template&id=8b072ef2&functional=true&"
import script from "./triple_arrows.vue?vue&type=script&lang=js&"
export * from "./triple_arrows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports